module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Medium-WebS.55a16895.ttf";